import { Http } from '@/lib/http';
import { assertRangeRows } from '@/modules/shared/utils/range-row-limits.mjs';
export class LoanFeeService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/loan-fees/';
  }
  createLoanFee(payload) {
    assertRangeRows(payload?.feePolicy);
    return this.httpClient().post(`${this.endpoint}`, payload);
  }
  getLoanFees() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  getLoanFee(id) {
    return this.httpClient().get(`${this.endpoint}${id}`);
  }
  updateLoanFee(id, payload) {
    assertRangeRows(payload?.feePolicy);
    return this.httpClient().patch(`${this.endpoint}${id}`, payload);
  }
  deleteLoanFee(id) {
    return this.httpClient().delete(`${this.endpoint}${id}`);
  }
}
